<template>
  <div>
    <select 
      v-model="selected"
      :class="{ 'is-invalid': error,'form-control':true}"
      tabindex="4"
      data-vv-scope="step1"
    >
      <option value="undefined">Seleccione</option>
      <option v-for="(option, index) in options" v-bind:value="option.value" :key="index">{{ option.text }}</option>
    </select>
  </div>
</template>

<script>
import axios from "axios";
import config from "../../../helpers/config";

export default {
  props: {
    filter: Number,
    onClick: Function,
    municipality_id: Number,
    error: Boolean
  },
  mounted() {
    
  },
  data() {
    return {
      selected: undefined,
      options: []
    };
  },
  watch: {
    selected: function(newVal, oldVal) {
      // watch it
      this.onClick(newVal);
    },
    filter: function(newVal, oldVal) {
      ////console.log(newVal)
      this.getMunicipalities(newVal);
    }
  },
  methods: {
    getMunicipalities(dep = 0) {
      this.options = [];
      return axios
        .get(
          `${config.urlApi}/locationMunicipalities?filter[where][locationDepartmentId]=${dep < 10 ? '0' + dep: dep}`,
          {}
        )
        .then(response => {
          response.data.forEach(element => {
            this.options.push({
              value: element.id,
              text: element.municipality
            })
          });
        })
        .catch(function(error) {
          ////////console.log(error)
        });
    }
  }
};
</script>
